// extracted by mini-css-extract-plugin
export default {"socialButtons":"Gbbe141","pageSocialButtons":"G70528b","componentSocialButtons":"G09b706","mobileHide":"Gbe05b9","mobileShow":"Gda9144"};